import { CheckCircle } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get("order_id");

  useEffect(() => {
    // If no order_id, redirect to home after a delay
    if (!orderId) {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [orderId, navigate]);

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 80px)",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <Box>
        <CheckCircle sx={{ fontSize: 80, color: "green" }} />
      </Box>

      <Typography fontSize="28px" fontWeight="700" sx={{ mt: 3, mb: 2 }}>
        Payment Successful!
      </Typography>

      {orderId && (
        <Typography fontSize="16px" color="text.secondary" sx={{ mb: 2 }}>
          Order ID: <strong>{orderId}</strong>
        </Typography>
      )}

      <Typography fontSize="18px" sx={{ mb: 4, maxWidth: 600 }}>
        Your eTicket and invoice have been sent to your email.
        Please check your inbox and spam folder.
      </Typography>

      <Button variant="contained" href="/" size="large">
        Back to Home
      </Button>
    </Box>
  );
}
